import {React, useEffect, useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import { TextAreaField } from "../../../components/Form/FormComponents";
import ActionSideBar from "../partials/ActionSideBar";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { InspectionInformationLease } from "../partials/FormFieldsLease";
import { InspectionInformationAF } from "../partials/FormFieldsAF";
// import { Button } from "@mui/material";

// eslint-disable-next-line no-unused-vars
const InspectedForm = ({ requestData, setRequestData, filter }) => {
	const [formData, setFormData] = useState(requestData);
	const [action, setAction] = useState("view");
	const isEditable = action === "edit";
	const isLeasing = filter === "lease";

	const [formattedDate, setFormattedDate] = useState("");
	const [dbDateObject, setDbDateObject] = useState({
		__type: "Date",
		iso: formData?.lastInspected?.iso, 
	});

	useEffect(() => {
		const isoDate = dbDateObject?.iso;
		const formattedDate = isoDate?.substring(0, 16);
		setFormattedDate(formattedDate);
	}, [dbDateObject]);
	
	//state for inspected due date date,
	const handleDateChange = (e) => {
		const newIsoDate = new Date(e.target.value + ":00Z").toISOString();
		setFormattedDate(e.target.value);
		setDbDateObject({ __type: "Date", iso: newIsoDate });
		setFormData({...formData, lastInspected: { __type: "Date", iso: newIsoDate }})
	};


	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleCancel = () => {
		setFormData(requestData);
		setAction("view");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log(formData);
		setRequestData(formData);
	};

		//editable fields for  Inspected assets
		const updatedData = {
			leaseData: {
				warranty: formData?.warranty,
				inspectionRoutine: formData?.inspectionRoutine,
				inspectionFee: formData?.inspectionFee,
				lastInspected: formData?.lastInspected,
				inspectionStatus:formData?.inspectionStatus,
				inspectionComment: formData?.inspectionComment,
			},
			AfData: {
				warranty: formData?.warranty,
				inspectionRoutine: formData?.inspectionRoutine,
				inspectionFee: formData?.inspectionFee,
				lastInspected: formData?.lastInspected,
				inspectionStatus:formData?.inspectionStatus,
				maintenanceComment: formData?.maintenanceComment,
			},
		};

	

	return (
		<>
			<StyledForm onSubmit={handleSubmit}>
				<ActionSideBar
					requestData={formData}
					action={action}
					setAction={setAction}
					handleCancel={handleCancel}
					updatedData={updatedData}
				/>

				<div className='RightSection'>
					<FormAccordion title='Inspection Information' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							{isLeasing ? (
								<InspectionInformationLease
									formData={formData}
									isEditable={isEditable}
									handleInputChange={handleInputChange}
									handleDateChange={handleDateChange}
									formattedDate={formattedDate}
								/>
							) : (
								<InspectionInformationAF
									formData={formData}
									isEditable={isEditable}
									handleInputChange={handleInputChange}
									handleDateChange={handleDateChange}
									formattedDate={formattedDate}
								/>
							)}
						</div>
					</FormAccordion>

					<FormAccordion title='Comment' open={true}>
						<div className='form-group'>
							<TextAreaField
								name='inspectionComment'
								isEditable={isEditable}
								value={formData?.inspectionComment || formData?.productId?.comment}
								handleChange={handleInputChange}
							/>
						</div>
					</FormAccordion>

					{/* <div className='flex'>
						<Button variant='contained' type='submit'>
							Save
						</Button>

						<Button variant='outlined' onClick={handleCancel}>
							Cancel
						</Button>
					</div> */}
				</div>
			</StyledForm>
		</>
	);
};

// Props Validation
InspectedForm.propTypes = {
	requestData: PropTypes.object,
	setRequestData: PropTypes.func,
	filter: PropTypes.string,
};

export default InspectedForm;
